import { deriveStatusItems } from '../state/banner';
import type { RepertoireNode } from '../api/types';

export interface StatusBannerProps {
  node: RepertoireNode | null;
  hideTransposition?: boolean;
}

/**
 * Top-of-page status strip (learning spec §7.4): transposition, branch, and
 * contradiction signals derived from the current `RepertoireNode`. Text is the
 * primary signal; the colored border is a secondary cue.
 */
export function StatusBanner({
  node,
  hideTransposition = false,
}: StatusBannerProps): JSX.Element | null {
  const items = deriveStatusItems(node).filter(
    (item) => !hideTransposition || item.kind !== 'transposition',
  );
  if (items.length === 0) return null;
  return (
    <div className="status-banner" role="status">
      {items.map((item) => (
        <p key={item.kind} className={`status-item status-${item.kind}`}>
          {item.text}
        </p>
      ))}
    </div>
  );
}
